module.exports = __webpack_public_path__ + "static/media/ebarchitects_kabeza20218.095b4903.jpg";